import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/apiClient";

let _cache = null;
let _subs = new Set();

async function _refresh() {
  try {
    const { data } = await api.get("/assets");
    _cache = data || {};
    _subs.forEach((fn) => fn(_cache));
  } catch {
    _cache = _cache || {};
  }
}

export function useAssets() {
  const [assets, setAssets] = useState(_cache);
  useEffect(() => {
    _subs.add(setAssets);
    if (_cache == null) _refresh();
    else setAssets(_cache);
    return () => { _subs.delete(setAssets); };
  }, []);
  const refresh = useCallback(() => _refresh(), []);
  return { assets: assets || {}, refresh };
}

export function useAsset(slot, fallback) {
  const { assets } = useAssets();
  const a = assets[slot];
  return {
    url: a?.image_url || fallback,
    alt: a?.alt || "",
    caption: a?.caption || "",
    visible: a ? a.is_visible !== false : true,
    slot,
  };
}

export function ManagedImage({ slot, fallback, alt: altOverride, className, ...rest }) {
  const a = useAsset(slot, fallback);
  if (!a.visible || !a.url) return null;
  return <img src={a.url} alt={altOverride || a.alt || ""} className={className} {...rest} />;
}
